// eslint-disable-next-line no-unused-vars
exports.install = function (Vue, options) {
    Vue.prototype.commonToUpper = function (str){
            str=str.toLowerCase()
            var bs = str.charAt(0);
            var cs = bs.toUpperCase();
            var ds = cs + str.slice(1);
            return ds.replaceAll("_"," ")
    };
};
